export const required = value => (value ? undefined : "* required");
export const mustBeNumber = value => {
  return value && (isNaN(value) && value !== "-")
    ? "* must be a number"
    : undefined;
};
export const minValue = min => value =>
  (isNaN(value) && value !== "-") || value >= min
    ? undefined
    : `* should be greater than ${min}`;

export const matchEmail = (value, other) => (value ? undefined : "must match");

export const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const mustBeICD10 = value => {
  var regex1 = RegExp(/[A-TV-Z][0-9][A-Z0-9](\.?[A-Z0-9]{0,4})?/);
  return value && !regex1.test(value) ? "* IDC must be valid" : undefined;
};
export const mustBeEmail = value => {
  var regex1 = RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return value && !regex1.test(value) ? "* must be a valid email" : undefined;
};
//    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Form/validators.js